export default __webpack_public_path__ + "static/media/invitationEn.9a820b81.jpg";